import React, { useEffect, useState } from 'react'
import queryString from 'query-string';
import axios from 'axios'
import { Alert, Col, Row, Spinner } from 'react-bootstrap';
import FormAddCard from './FormAddCard';
import FormCheckEmail from './FormCheckEmail';

const checkIsValidReceipt = (rec) => {
    // 0ENR 01 0612 0000 130 
    // 0ENR010612000013041
    const kassa = Number(rec.slice(4, 6))
    const smena = Number(rec.slice(6, 10))
    const check = Number(rec.slice(10, 17))
    const check_result = rec.slice(17, rec.length)

    let checksum = ((kassa * 9 + check) * 3 + (smena * 2)) % 100

    if (checksum < 10) {
        checksum = "0" + checksum
    }
    if (checksum == check_result) return true
    else return false
}


// форма регистрации бонусной карты  
const Type10 = ({ data, pageData }) => {

    const query = queryString.parse(window.location.search)
    const { receipt, number_card } = query

    const [isValidReceipt, setIsValidReceipt] = useState(true);

    const [userInfo, setUserInfo] = useState(null)
    const [isLoadingUser, setIsLoadingUser] = useState(true); // загрузка jwt 

    const [warningMassage, setWarningMassage] = useState(null)

    useEffect(() => {
        const checkUser = () => {
            setIsLoadingUser(true)
            if (!localStorage.getItem('galaxy-token')) {
                setIsLoadingUser(false)
                return false
            }
            axios.post(`${process.env.REACT_APP_API_BASE}/cabinet/profile`, {
                jwt: localStorage.getItem('galaxy-token')
            })
                .then(response => {
                    if (response?.data?.data?.info) {
                        setUserInfo(response.data.data.info)
                    }
                    else {
                        setUserInfo(null)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
                .finally(() => {
                    setIsLoadingUser(false)
                })

        }
        checkUser()
    }, [])

    useEffect(() => {
        if (receipt) {
            if (checkIsValidReceipt(receipt)) {
                setIsValidReceipt(true)
            }
            else {
                setIsValidReceipt(false)
            }
        }
    }, [receipt]);


    if (!receipt) return <></>
    if (!isValidReceipt) return (
        <Alert variant={'danger'}  >
            <Alert.Heading style={{ fontSize: '1.15rem' }}>Неправильный чек</Alert.Heading>
            <p className='mb-0'>{'Проверьте правильность чека'}</p>
        </Alert>
    )

    return (
        <div className='buildedPage-type_8' >
            {
                isLoadingUser ?
                    <Row className='justify-content-center'>
                        <Col md={8} lg={8} xl={6} className='mb-2' >
                            <div className='light buildedPage-type_8-form' style={{ height: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Spinner animation='border' />
                            </div>
                        </Col>
                    </Row>
                    :
                    <>
                        {
                            userInfo ?
                                <FormAddCard
                                    data={data}
                                    userInfo={userInfo}
                                    query={query}
                                    pageData={pageData}
                                    warningMassage={warningMassage}
                                    setWarningMassage={setWarningMassage}
                                />
                                :
                                <FormCheckEmail
                                    setWarningMassage={setWarningMassage}
                                    data={data}
                                    query={query}
                                    setUserInfo={setUserInfo}
                                    pageData={pageData}
                                />
                        }
                    </>
            }
        </div >
    )
}

export default Type10